import { mixpanelInitialized } from '@/lib/integrations/analytics/mixpanel/mixpanelClient';
import mixpanel from 'mixpanel-browser';

const isDevelopment = process.env.NODE_ENV === 'development';

export const track = (event: string, properties?: Record<string, any>) => {
  if(mixpanelInitialized && !isDevelopment){
    mixpanel.track(event, properties || {});
  }
}

export const trackPageView = (url: string) => {
  if(mixpanelInitialized  && !isDevelopment){
    mixpanel.track('Page View', { url });
  }
}

export const identify = (distinctId: string) => {
  if(mixpanelInitialized  && !isDevelopment){
    mixpanel.identify(distinctId);
  }
}